import { palette } from '../palette';

declare module '@mui/material/TableCell' {
  interface TableCellPropsVariantOverrides {
    clampedText: true;
    twoLineFullLength: true;
  }
}

export const MuiTable = {
  styleOverrides: {
    root: {
      borderBottom: `1px solid ${palette.custom.gray[200]}`,
      borderTop: `1px solid ${palette.custom.gray[200]}`,
    },
  },
};

export const MuiTableRow = {
  styleOverrides: {
    root: {
      height: '40px',
      minHeight: '40px',
      '&.MuiTableRow-hover:hover': {
        cursor: 'pointer',
        backgroundColor: palette.custom.gray[25],
      },
    },
  },
};

export const MuiTableCell = {
  variants: [
    {
      props: { variant: 'clampedText' },
      style: {
        minWidth: '160px',
        paddingTop: 0,
        paddingBottom: 0,
        '& .MuiTypography-root': {
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',
          hyphens: 'auto',
        },
      },
    },
  ],
  styleOverrides: {
    root: {
      color: palette.custom.gray[600],
      fontWeight: 500,
      fontSize: '12px',
      borderBottom: `1px solid ${palette.custom.gray[200]}`,
      paddingTop: '6px',
      paddingBottom: '6px',
      paddingLeft: '8px',
      paddingRight: '8px',
      height: '40px',
      minHeight: '40px',
      display: 'table-cell',
      verticalAlign: 'middle',
    },
    head: {
      height: '45px',
      color: palette.custom.gray[600],
      fontWeight: 600,
      fontSize: '12px',
      borderBottom: `1px solid ${palette.custom.gray[200]}`,
      backgroundColor: palette.common.white,
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: '8px',
      paddingRight: '8px',
    },
  },
};
